import {
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
} from '@mui/material'

/**
 * Displayes a `Table` component, with the *headers* as the *first column* and the *content* as the *second column*.
 */
export const KeyValueTable: React.FC<{
    rows: { label: string; value: React.ReactNode }[]
}> = ({ rows }) => (
    <TableContainer>
        <Table>
            <TableBody>
                {rows.map(({ label, value }) => (
                    <TableRow key={label}>
                        <TableCell
                            variant={'head'}
                            component={'th'}
                            style={{ width: '20%' }}
                        >
                            {label}:
                        </TableCell>
                        <TableCell>{value}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)
